import MainLayout from "../../layouts/MainLayout";
import { IoShieldCheckmarkOutline, IoMailOutline, IoCallOutline, IoLocationOutline } from "react-icons/io5";
import "./styles.css";

const sections = [
  {
    num: "١",
    title: "مقدمة",
    body: "نحن في عقاراتي نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح هذه السياسة كيفية جمع واستخدام وحماية المعلومات التي تقدمها لنا عند استخدام موقعنا الإلكتروني وخدماتنا.",
  },
  {
    num: "٢",
    title: "المعلومات التي نجمعها",
    intro: "نقوم بجمع الأنواع التالية من المعلومات:",
    list: [
      "المعلومات الشخصية: الاسم، البريد الإلكتروني، رقم الهاتف، العنوان",
      "معلومات الاستخدام: كيفية تفاعلك مع موقعنا الإلكتروني",
      "المعلومات التقنية: عنوان IP، نوع المتصفح، نظام التشغيل",
      "ملفات تعريف الارتباط: لتحسين تجربتك وتخصيص المحتوى",
    ],
  },
  {
    num: "٣",
    title: "كيف نستخدم معلوماتك",
    intro: "نستخدم المعلومات المجمعة للأغراض التالية:",
    list: [
      "تقديم وتحسين خدماتنا",
      "التواصل معك والرد على استفساراتك",
      "إرسال التحديثات والإشعارات المهمة",
      "تخصيص تجربتك على الموقع",
      "إجراء التحليلات لتحسين الأداء",
      "الامتثال للمتطلبات القانونية",
    ],
  },
  {
    num: "٤",
    title: "مشاركة المعلومات",
    intro: "نحن لا نبيع أو نؤجر أو نشارك معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:",
    list: [
      "عند الحصول على موافقتك الصريحة",
      "لمقدمي الخدمات الذين يساعدوننا في تشغيل موقعنا",
      "عند الاقتضاء القانوني أو بناءً على أمر من السلطات",
      "لحماية حقوقنا وسلامة المستخدمين",
    ],
  },
  {
    num: "٥",
    title: "أمان البيانات",
    body: "نتخذ تدابير أمنية مناسبة لحماية معلوماتك من الوصول غير المصرح به أو التغيير أو الإفصاح أو التدمير. نستخدم التشفير والجدران النارية وإجراءات الأمان الأخرى لحماية بياناتك.",
  },
  {
    num: "٦",
    title: "حقوقك",
    intro: "لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:",
    list: [
      "الحق في الوصول: طلب نسخة من بياناتك الشخصية",
      "الحق في التصحيح: تصحيح أي معلومات غير دقيقة",
      "الحق في المحو: طلب حذف بياناتك الشخصية",
      "الحق في النقل: الحصول على بياناتك بتنسيق قابل للقراءة",
      "الحق في الاعتراض: الاعتراض على معالجة بياناتك",
    ],
  },
  {
    num: "٧",
    title: "ملفات تعريف الارتباط",
    body: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. يمكنك التحكم في هذه الملفات من خلال إعدادات متصفحك.",
  },
  {
    num: "٨",
    title: "الاحتفاظ بالبيانات",
    body: "نحتفظ ببياناتك الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها أو كما هو مطلوب بموجب القانون. بعد انتهاء هذه المدة، سيتم حذف البيانات أو إخفاء هويتها بشكل آمن.",
  },
  {
    num: "٩",
    title: "التغييرات على هذه السياسة",
    body: "قد نقوم بتحديث هذه السياسة من وقت لآخر. سنخطرك بأي تغييرات مهمة عبر البريد الإلكتروني أو من خلال إشعار على موقعنا.",
  },
];

function PrivacyPage() {
  return (
    <MainLayout isTopBar screenTitle="سياسة الخصوصية">
      <div className="sp-wrap" dir="rtl">

        <div className="sp-hero">
          <div className="sp-hero__icon">
            <IoShieldCheckmarkOutline size={32} />
          </div>
          <h1 className="sp-hero__title">سياسة الخصوصية</h1>
          <p className="sp-hero__sub">نحن نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية</p>
        </div>

        <div className="sp-doc-card">
          {sections.map(s => (
            <div key={s.num} className="sp-doc-section">
              <div className="sp-doc-section__head">
                <div className="sp-doc-section__num">{s.num}</div>
                <h2 className="sp-doc-section__title">{s.title}</h2>
              </div>
              {s.intro && <p>{s.intro}</p>}
              {s.body  && <p>{s.body}</p>}
              {s.list  && (
                <ul>
                  {s.list.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              )}
            </div>
          ))}

          {/* Section 10 — contact */}
          <div className="sp-doc-section">
            <div className="sp-doc-section__head">
              <div className="sp-doc-section__num">١٠</div>
              <h2 className="sp-doc-section__title">اتصل بنا</h2>
            </div>
            <p>إذا كانت لديك أي أسئلة حول هذه السياسة أو ممارسات الخصوصية لدينا، يرجى التواصل معنا:</p>
            <div className="sp-contact-box">
              <div className="sp-contact-row">
                <IoMailOutline size={17} />
                contact@aqaraty.ly
              </div>
              <div className="sp-contact-row">
                <IoCallOutline size={17} />
                <span dir="ltr">+218 444 444 444</span>
              </div>
              <div className="sp-contact-row">
                <IoLocationOutline size={17} />
                ليبيا، طرابلس
              </div>
            </div>
            <p className="sp-last-update">
              آخر تحديث: {new Date().toLocaleDateString('ar-LY', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>

      </div>
    </MainLayout>
  );
}

export default PrivacyPage;
